/* ============================================================================
   Auth module — public route for the self-service password reset page.
   Registered as a publicRoute so it renders OUTSIDE the authenticated shell:
   users arrive here logged out, via the token link in the reset email.
   No nav item — the page is only reached through that link.
   ============================================================================ */

import { registerRoute } from '../../app/registry';
import ResetPassword from './ResetPassword';

registerRoute({
  path: '/reset-password',
  element: <ResetPassword />,
  publicRoute: true,
});
